import { Component, OnInit } from '@angular/core';

declare function LoadPlyr(): any;

@Component({
  selector: 'app-resource-detail',
  templateUrl: './resource-detail.component.html',
  styleUrls: ['./resource-detail.component.css']
})
export class ResourceDetailComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    //const players = Array.from(document.querySelectorAll('.js-player')).map(player => new Plyr(player));
    //Array.from(document.querySelectorAll('.js-player')).map(player => new Plyr(player));
    LoadPlyr();
  }

  public playPause(): void {
    var myVideo = document.getElementById("video1") as HTMLVideoElement;

    if (myVideo.paused)
      myVideo.play();
    else
      myVideo.pause();
  }

  /**
   * get the curent range that the user has watched of the video
   */
  public getRangePlayed() {
    var vid = document.getElementById("video1") as HTMLVideoElement;
    if (vid.played.length > 0)
      alert("Start: " + vid.played.start(0) + " End: " + vid.played.end(0));
  }

  /**
   * IncreaseSpeed
   */
  public increaseSpeed() {
    var vid = document.getElementById("video1") as HTMLVideoElement;
    vid.playbackRate += 0.5
  }

  /**
  * DecreaseSpeed
  */
  public decreaseSpeed() {
    var vid = document.getElementById("video1") as HTMLVideoElement;
    vid.playbackRate -= 0.5
  }

  /**
   * requestFullScreen
   */
  public requestFullScreen() {
    var video = document.getElementById("video1") as HTMLVideoElement;

    if (video.requestFullscreen) {
      video.requestFullscreen();
    }
    /*else if (video.mozRequestFullScreen) {
      video.mozRequestFullScreen(); // Firefox
    } else if (video.webkitRequestFullscreen) {
      video.webkitRequestFullscreen(); // Chrome and Safari
    }*/
  }

  /**
   * updateSlider
   */
  public updateSlider() {
    // Calculate the slider value
    var video = document.getElementById("video1") as HTMLVideoElement;
    var Slider = document.getElementById("seek-bar") as HTMLProgressElement;
    var value = (100 / video.duration) * video.currentTime;

    // Update the slider value
    Slider.value = value;
  }
}
